export const SET_TITLE = "SET_TITLE"
export const SET_MOBILE_FLAG = "SET_MOBILE_FLAG"

export function changeTitle(title) {
    return {
        type: SET_TITLE,
        title
    }
}

export function setMobileFlag(isMobile) {
    return {
        type: SET_MOBILE_FLAG,
        isMobile
    }
}